import React, { useContext } from "react";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";

import {
  allowedFileUploadExtensions,
  allowedFileUploadMimeTypes,
} from "@examspark/common/dist/utils/file";

import { FormContext } from "../contexts/FormContext";

import { IconDownloadLine } from "./icons";

const Wrapper = styled.div`
  position: relative;
  &:hover {
    border-color: #006699;
  }
  .app-dropzone-button {
    padding-right: 1em;
  }
  .app-dropzone-text {
    flex: 1;
  }
`;

const ActiveDropShim = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 1.4rem;
  color: #333;

  svg {
    fill: #888;
  }
`;

const Dropzone: React.FC<
  React.PropsWithChildren<{
    allowedFileTypes?: string[];
    browseButtonRef?: React.RefObject<HTMLInputElement>;
    onDrop?: (files: File[]) => void;
    disabled?: boolean;
    multiple?: boolean;
  }>
> = (props) => {
  const form = useContext(FormContext);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: props.onDrop,
    multiple: props.multiple ?? true,
    disabled: props.disabled ?? form.disabled,
    accept: props.allowedFileTypes ?? [
      ...allowedFileUploadExtensions,
      ...allowedFileUploadMimeTypes,
    ],
  });

  return (
    <Wrapper {...getRootProps()}>
      <input {...getInputProps()} ref={props.browseButtonRef} />
      {props.children}
      {isDragActive && (
        <ActiveDropShim>
          <IconDownloadLine width="24" />
          <div>Drop files here...</div>
        </ActiveDropShim>
      )}
    </Wrapper>
  );
};
export default Dropzone;
